import { useContext } from 'react';
import { NotificationHandlerContext } from '../NotificationHandlerContext';
import { NotificationData } from '../notification-data';

const useNotifications = (): NotificationData[] => {
  const { notifications } = useContext(NotificationHandlerContext);

  return notifications;
};

export default useNotifications;
